import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useConfig } from '../contexts/ConfigContext';
import Footer from './Footer';

const PrayerRequest = () => {
  const navigate = useNavigate();
  const config = useConfig();

  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!message.trim()) {
      setError('Please enter a prayer request before submitting.');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      const payload = {
        name: name.trim() || 'Anonymous',
        message: message.trim(),
        created_at: Timestamp.fromDate(new Date()),
        status: 'new'
      };

      // Save to Firestore
      await addDoc(collection(db, 'prayer_requests'), payload);

      // Post to Google Sheet (if configured)
      if (config.prayerRequestsSheetUrl) {
        try {
          // mode: 'no-cors' is required for Google Apps Script endpoints — the POST
          // still reaches the sheet even though we can't read the response back.
          fetch(config.prayerRequestsSheetUrl, {
            method: 'POST',
            mode: 'no-cors',
            body: JSON.stringify({ name: payload.name, message: payload.message })
          });
        } catch (sheetErr) {
          // Don't block the user if the sheet POST fails
          console.error('Failed to post to Google Sheet:', sheetErr);
        }
      }

      navigate('/prayer-request/submitted');
    } catch (err) {
      console.error('Error submitting prayer request:', err);
      setError('Something went wrong. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <div className="stt-page">
      <div className="stt-content" style={{ paddingTop: '40px', paddingBottom: '60px' }}>
        <h1 className="stt-page-title">Prayer Requests</h1>
        <hr className="divider-gold" style={{ margin: '0 0 32px' }} />

        <p style={{ marginBottom: '28px', color: '#555', lineHeight: 1.7 }}>
          Enter a prayer request and we will be sure to pray for you.
          All prayer requests are anonymous unless you'd like to leave your name.
        </p>

        <div style={{ maxWidth: '560px' }}>
          <div style={{ marginBottom: '20px' }}>
            <label className="stt-form-label" htmlFor="prayer-name">Name</label>
            <p className="stt-form-hint">Optional — leave blank to remain anonymous</p>
            <input
              id="prayer-name"
              type="text"
              className="form-control"
              placeholder="Anonymous"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label className="stt-form-label" htmlFor="prayer-message">Prayer Request</label>
            <textarea
              id="prayer-message"
              className="form-control"
              rows={5}
              placeholder="Write your prayer request here..."
              value={message}
              onChange={e => setMessage(e.target.value)}
            />
          </div>

          {error && (
            <p style={{ color: 'red', fontSize: '0.88rem', marginBottom: '16px' }}>{error}</p>
          )}

          <button
            className="btn stt-btn-primary"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? 'Submitting...' : 'Submit Prayer Request'}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrayerRequest;
